// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WebhookIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="#C73A63"
      fillRule="evenodd"
      d="m11.3 10.3-2.74 4.6c-.24.38-.36.7-.16 1.2a2.24 2.24 0 0 1-1.58 3.04c-1.3.34-2.56-.52-2.82-1.9-.22-1.22.72-2.44 2.08-2.62l.42-.04 2.06-3.46a5.7 5.7 0 0 1-1.9-4.66 5.35 5.35 0 0 1 8.3-4.06 5.2 5.2 0 0 1 2.2 6.08q-.9-.23-1.88-.52a3.6 3.6 0 0 0-.76-3.26 3.2 3.2 0 0 0-2.04-1.06 3.3 3.3 0 0 0-3.62 2.34q-.82 2.68 2.44 4.32"
      clipRule="evenodd"
    />
    <path
      fill="#4B4B4B"
      fillRule="evenodd"
      d="m13.96 8.44 2 3.52a5.46 5.46 0 0 1 6.78 2.8c1.1 2.4.34 5.24-1.8 6.72a5.3 5.3 0 0 1-6.96-.7l1.54-1.28c1.94 1.26 3.62 1.2 4.88-.28a3.4 3.4 0 0 0-.06-4.38c-1.28-1.42-2.98-1.48-5.02-.1q-1.3-2.27-2.56-4.54c-.28-.52-.58-.82-1.22-.92a2.16 2.16 0 0 1-1.76-2.1 2.3 2.3 0 0 1 1.46-2.26 2.3 2.3 0 0 1 2.6.7c.5.64.66 1.34.4 2.12-.08.24-.18.44-.28.7"
      clipRule="evenodd"
    />
    <path
      fill="#4A4A4A"
      fillRule="evenodd"
      d="M15.54 17.96H11.5a5.5 5.5 0 0 1-2.66 3.7q-1.68.97-3.6.64a5.54 5.54 0 0 1-4.48-4.92 5.4 5.4 0 0 1 4.16-5.66l.52 1.88Q2.03 15.34 3 18.06a3.33 3.33 0 0 0 3.9 2.16c1.78-.34 2.66-1.82 2.56-4.18q2.52-.02 5.04 0c.66.02 1.16-.06 1.66-.64.82-.96 2.3-.86 3.18.04a2.3 2.3 0 1 1-3.32 3.16q-.23-.3-.48-.64"
      clipRule="evenodd"
    />
  </svg>,
  "Webhook",
);
export default WebhookIcon;
